import type { Prayer } from '@/types/prayer';
import { whoOf } from './prayer-utils';

type TFn = (key: string, opts?: Record<string, unknown>) => string;

/**
 * Returns the right aria-label for a "Send a card" affordance. Used by
 * both the Garden vine airplane and the leaf-sheet "Send a card" row so
 * blind users hear the same description on both surfaces.
 *
 *   - Self or General    → t('share.shareCardAriaUnnamed')
 *                          (warm generic, no recipient interpolation)
 *   - named prayer       → t('share.sendCardAria', { name })
 *                          (name-aware "Send a card to {{name}}…")
 */
export function shareAriaForPrayer(prayer: Prayer, t: TFn): string {
  const who = whoOf(prayer);
  if (who === 'Self' || who === 'General') return t('share.shareCardAriaUnnamed');
  return t('share.sendCardAria', { name: who });
}
